export const RETURN_TO_APPLICATION_AUTO = 'return_to_application_auto'
export const INSTANT_DASHING_V2 = 'instant_dashing_v2'
export const INSTANT_DASHING = 'instant_dashing'
export const IS_AT_CAPACITY_V2 = 'is_at_capacity_v2'
export const DX_INSTANT_DASHING_NO_ACTIVATION_KIT =
  'dx_instant_dashing_no_activation_kit'
export const DX_CRO_LP_GRADUATION_Q3_2020 = 'dx_cro_lp_graduation_q3_2020'
export const DX_ID_FAST_PAY_Q1_2020 = 'dx_id_fast_pay_q1_2020'
export const NEEDS_VEHICLE_INFO = 'needs_vehicle_info'
export const DX_EXTREME_LATENESS = 'dx_extreme_lateness'
export const W_MODEL_EXPERIMENT = 'w_model_experiment'
export const NEEDS_OFFER_LETTER = 'needs_offer_letter'
export const DX_PHONE_NUMBER_VERIFICATION = 'phone_number_verification'
export const TOKENIZATION = 'tokenization'
export const DX_WEB_JAPAN_SUPPORT = 'dx_web_jpn_support'
export const DX_PHONE_NUMBER_VERIFICATION_SIGNUP =
  'dasher_phone_number_verification_signup'
export const NO_W9_EXPERIMENT = 'no_w9_experiment'
export const ADDRESS_COLLECTION_AFTER_DASH = 'address_collection_after_dash'
export const ADDRESS_COLLECTION_AFTER_X_DASHES =
  'address_collection_after_x_dashes'
export const IDENTITY_VERIFICATION = 'identity_verification'
export const IDENTITY_VERIFICATION_ANDROID = 'identity_verification_android'
export const HAS_COMPLETED_FIRST_DELIVERY = 'has_completed_first_delivery'
export const BGC_STATUS_UPDATE = 'bgc_status_update'
export const DX_SAFETY_COURSE = 'dx_safety_course'
export const DASHER_WEB_IDENTITY_SERVICE_MIGRATION =
  'dasher_web_identity_service_migration'
export const DX_BANK_ACCOUNT_SKIP = 'dx_bank_account_skip'
export const DASHER_PRIVACY_PORTAL = 'dx_show_privacy_portal'
export const DX_ACTIVATED_NO_FIRST_DASH = 'dx_activated_no_first_dash'
export const DX_ACTIVATED_NO_FIRST_DASH_IOS = 'dx_activated_no_first_dash_ios'
export const DX_ACTIVATED_NO_FIRST_DASH_LOCATION =
  'dx_activated_no_first_dash_location'
export const AN_DX_ANFD_ONBOARDING = 'an_dx_anfd_onboarding'
export const REFERRAL_CODE_REMOVAL = 'referral_code_removal'

// this is just a combo of experiments
export const ADDRESS_COLLECTION_INSTANT_DASH = 'address_collection_instant_dash'
export const IDV_REFERRAL = 'idv_referral'
export const IDV_SESSION_LIMIT = 'idv_session_limit'
export const IDV_PERSONA_MIGRATION = 'idv_persona_migration'

export const AUS_NCC_BGC = 'aus_ncc_bgc'
export const GERMANY_DX_ONBOARDING_V2 = 'germany_dx_onboarding_v2'
export const JAPAN_DX_ONBOARDING_PLATFORM_MIGRATION =
  'japan_dx_onboarding_platform_migration'
export const JAPAN_DX_ENABLE_ORIENTATION = 'japan_dx_enable_orientation'

export const DX_EXCITEMENT_PROMOTIONS_PAGE = 'dx_excitement_promotions_page'
export const DX_EXCITEMENT_PROFILE_PAGE = 'dx_excitement_profile_page'

export const USE_USER_ME_ENDPOINT = 'use_user_me_endpoint'
export const DX_DRIVERS_LICENSE_TOKENIZATION = 'dx_drivers_license_tokenization'
// feature flag for onbarding (NZ)
export const DX_ONBOARDING_V2 = 'dx_onboarding_v2'

export const DX_BACKGROUND_CHECK_DESCRIPTION_COPY_V2 =
  'dx_background_check_description_copy_v2'

export const DASHER_ONBOARDING_PLATFORM_BFF = 'dasher_onboarding_platform_bff'
export const DX_FORM_FOCUS_ENTER_KEY = 'dx_form_focus_enter_key'

export const IN_APP_EDUCATION_V4 = 'in_app_education_v4'
// TODO(DG-2361): Use v3 for /dasher/me calls
export const DX_USE_V3_API = 'dx_use_v3_api'
export const SCAN_DL_BACK = 'scan_dl_back'
export const BGC_AUTO_REFRESH = 'bgc_auto_refresh'
// background check link page in webview if not started/incomplete
export const BGC_EXTERNAL_LINK = 'bgc_external_link'
// in-house ncc background check link page
export const DX_CRO_BGC_NCC_LINK_GRADUATION = 'dx_cro_bgc_ncc_link_graduation'
// pre-fill Dx info to streamline NCC checks
export const DX_BGC_NCC_CONSUMER_INTEGRATION = 'dx_bgc_ncc_consumer_integration'
// share existing NCC background check
export const DX_BGC_NCC_CHECK_SHARE = 'dx_bgc_ncc_check_share'
// [AU] ABN reposition
export const DX_AU_ABN_REPOSITION = 'dx_au_abn_reposition'
// TODO(DG-2467): Remove identity_login_banner experiment when rolled out
export const IDENTITY_LOGIN_BANNER = 'identity_login_banner'

export const DX_BGC_ONBOARDING_PLATFORM = 'dx_bgc_onboarding_platform'
// NZL-325: Hide Fastpay messages for NZ
export const HIDE_FASTPAY_MESSAGE = 'hide_fastpay_message'
export const HIDE_BANKACCOUNT_HELP = 'hide_bankaccount_help'

// TODO(DG-2821): Remove dx_r2a_skip_phone experiment when rolled out
export const DX_R2A_SKIP_PHONE = 'dx_r2a_skip_phone'
export const DX_R2A_RECLAIM_EMAIL = 'dx_r2a_reclaim_email'

// TODO(DG-2558): Remove identity_signup_migration experiment when rolled out
export const IDENTITY_SIGNUP_MIGRATION = 'identity_signup_migration'
export const DX_R2A_DOUBLE_MATCH = 'dx_r2a_double_match'
export const DX_R2A_LOCAL_STORAGE_AUTO_RESUME =
  'dx_r2a_local_storage_auto_resume'

// TODO(DG-2991): Remove dx_excitement_auto_scroll experiment when rolled out
export const DX_EXCITEMENT_AUTO_SCROLL = 'dx_excitement_auto_scroll'
export const DX_R2A_SMS_RECLAIM = 'dx_r2a_sms'
export const DX_WOLT_JP_TRANSITION = 'dx_wolt_jp_transition'
export const DX_ONBOARDING_TRACKING_EVENT_MIGRATION =
  'dx_onboarding_tracking_event_migration'

export const DX_APP_DASHER_ONBOARDING_REDIRECT = 'dx_app_dasher_onboarding_redirect'

export const DX_ADD_BANK_ACCOUNT_FORM_SUBMIT_SEGMENT_EVENT = 'dx_add_bank_account_form_submit_segment_event'

export default {
  RETURN_TO_APPLICATION_AUTO,
  INSTANT_DASHING,
  INSTANT_DASHING_V2,
  IS_AT_CAPACITY_V2,
  DX_CRO_LP_GRADUATION_Q3_2020,
  DX_ID_FAST_PAY_Q1_2020,
  NEEDS_VEHICLE_INFO,
  DX_EXTREME_LATENESS,
  W_MODEL_EXPERIMENT,
  NEEDS_OFFER_LETTER,
  DX_PHONE_NUMBER_VERIFICATION,
  TOKENIZATION,
  DX_WEB_JAPAN_SUPPORT,
  DX_PHONE_NUMBER_VERIFICATION_SIGNUP,
  NO_W9_EXPERIMENT,
  ADDRESS_COLLECTION_AFTER_DASH,
  IDENTITY_VERIFICATION,
  IDENTITY_VERIFICATION_ANDROID,
  HAS_COMPLETED_FIRST_DELIVERY,
  ADDRESS_COLLECTION_INSTANT_DASH,
  BGC_STATUS_UPDATE,
  DX_SAFETY_COURSE,
  DASHER_WEB_IDENTITY_SERVICE_MIGRATION,
  DX_BANK_ACCOUNT_SKIP,
  IDV_PERSONA_MIGRATION,
  IDV_REFERRAL,
  DASHER_PRIVACY_PORTAL,
  DX_ACTIVATED_NO_FIRST_DASH,
  DX_ACTIVATED_NO_FIRST_DASH_IOS,
  IDV_SESSION_LIMIT,
  AN_DX_ANFD_ONBOARDING,
  REFERRAL_CODE_REMOVAL,
  AUS_NCC_BGC,
  GERMANY_DX_ONBOARDING_V2,
  JAPAN_DX_ONBOARDING_PLATFORM_MIGRATION,
  JAPAN_DX_ENABLE_ORIENTATION,
  DX_ACTIVATED_NO_FIRST_DASH_LOCATION,
  DX_EXCITEMENT_PROMOTIONS_PAGE,
  DX_EXCITEMENT_PROFILE_PAGE,
  USE_USER_ME_ENDPOINT,
  DX_DRIVERS_LICENSE_TOKENIZATION,
  DX_ONBOARDING_V2,
  DX_BACKGROUND_CHECK_DESCRIPTION_COPY_V2,
  DASHER_ONBOARDING_PLATFORM_BFF,
  IN_APP_EDUCATION_V4,
  DX_FORM_FOCUS_ENTER_KEY,
  DX_USE_V3_API,
  DX_BGC_ONBOARDING_PLATFORM,
  SCAN_DL_BACK,
  BGC_AUTO_REFRESH,
  IDENTITY_LOGIN_BANNER,
  BGC_EXTERNAL_LINK,
  HIDE_FASTPAY_MESSAGE,
  HIDE_BANKACCOUNT_HELP,
  DX_CRO_BGC_NCC_LINK_GRADUATION,
  IDENTITY_SIGNUP_MIGRATION,
  DX_R2A_DOUBLE_MATCH,
  DX_R2A_LOCAL_STORAGE_AUTO_RESUME,
  DX_BGC_NCC_CONSUMER_INTEGRATION,
  DX_R2A_SKIP_PHONE,
  DX_EXCITEMENT_AUTO_SCROLL,
  DX_R2A_SMS_RECLAIM,
  DX_BGC_NCC_CHECK_SHARE,
  DX_WOLT_JP_TRANSITION,
  DX_ONBOARDING_TRACKING_EVENT_MIGRATION,
  DX_AU_ABN_REPOSITION,
  DX_APP_DASHER_ONBOARDING_REDIRECT,
  DX_ADD_BANK_ACCOUNT_FORM_SUBMIT_SEGMENT_EVENT
}
